import { LightMotion } from "../components/LightMotion";
import type { ReactNode } from "react";
import { Button, Field, IconButton } from "../components/rumonai";
import { Icon } from "../components/Icon";
import ribbonUrl from "../assets/pa-ribbon.webp";
import "./auth.css";

/**
 * The page every way into an account shares: the brand on the left, one quiet
 * column on the right. Signing in, creating an account, asking for a reset link
 * and opening one from a mail are all this page with a different column.
 */
export function AuthShell({ title, lead, children }: {
  title: string;
  lead?: ReactNode;
  children?: ReactNode;
}) {
  return (
    <main className="hub-auth-layout">
      <section className="auth-brand" aria-label="涟漪">
        <img className="auth-artwork" src="/brand/auth-monet.webp" alt="" />
        <a className="auth-wordmark" href="/" aria-label="涟漪首页">
          <img src={ribbonUrl} alt="" />
          <span>涟漪</span>
        </a>
        <div className="auth-brand-copy">
          <h2>让你的判断，<br />成为一个 IP。</h2>
          <p>内容 · 风格 · 持续经营</p>
        </div>
      </section>
      <section className="auth-form-side" aria-label="账号登录">
        <div className="auth-form-content">
          <header className="auth-heading">
            <h1>{title}</h1>
            {lead ? <p>{lead}</p> : null}
          </header>
          {children}
        </div>
      </section>
    </main>
  );
}

/** A password box with the eye that shows it; the one every page of this column uses. */
export function PasswordField({ label, placeholder, value, onChange, autoComplete, setting, disabled, hidden, onHide, name = "password", hint }: {
  label: string;
  placeholder: string;
  name?: string;
  hint?: ReactNode;
  value: string;
  onChange: (value: string) => void;
  autoComplete: "current-password" | "new-password";
  /** Setting a password holds it to the length rule and says so. */
  setting: boolean;
  disabled: boolean;
  /** Whether the text is hidden; the page owns it so a mode change can hide it again. */
  hidden: boolean;
  onHide: (hidden: boolean) => void;
}) {
  return <div className="auth-password">
    <Field label={label} hint={hint} suffix={<IconButton name={hidden ? "eye" : "eye-off"} label={(hidden ? "显示" : "隐藏") + label}
      className="auth-password-toggle" aria-pressed={!hidden} disabled={disabled} onClick={() => onHide(!hidden)} />}>
      <input name={name} type={hidden ? "password" : "text"} autoComplete={autoComplete}
        minLength={setting ? 8 : undefined} placeholder={placeholder} value={value}
        onChange={event => onChange(event.target.value)} required disabled={disabled} />
    </Field>
  </div>;
}

/** The submit button every page of this column ends with: busy follows the request and what it is doing. */
export function SubmitButton({ busy, doing, children, disabled }: {
  busy: boolean;
  doing: string;
  children: ReactNode;
  disabled?: boolean;
}) {
  return <Button className="auth-submit" type="submit" aria-busy={busy} disabled={busy || disabled}>
    <span>{busy ? doing : children}</span>
    {busy ? <LightMotion state="working" compact /> : <Icon name="arrow" size={18} />}
  </Button>;
}
